import type { ReactNode } from 'react';

import { useMenuItemDragAndDrop } from '@atlaskit/navigation-system/side-nav-items/drag-and-drop/use-menu-item-drag-and-drop';

type UseItemDragAndDropType = {
	icon: ReactNode;
	isReorderable?: boolean;
	label: string;
	type: 'shortcut-link-item';
};

const isItemDraggable = (isReorderable?: boolean | unknown) => {
	return isReorderable !== false;
};

export function useItemDragAndDrop({ type, label, icon, isReorderable }: UseItemDragAndDropType) {
	const isDraggable = isItemDraggable(isReorderable);

	const { draggableAnchorRef, dropIndicator, dropTargetRef, dragPreview, state } =
		useMenuItemDragAndDrop({
			draggable: {
				getInitialData: () => ({ type, label, isReorderable }),
				getDragPreviewPieces: () => ({
					content: label,
					elemBefore: icon,
				}),
				canDrag: () => isItemDraggable(isReorderable),
			},
			dropTarget: {
				getData: () => ({ type, label, isReorderable }),
				getOperations: () => ({
					'reorder-before': 'available',
					'reorder-after': 'available',
				}),
				canDrop: ({ source }) =>
					source.element !== dropTargetRef.current &&
					source.data.type === type &&
					isItemDraggable(source.data.isReorderable),
			},
		});

	return {
		draggableAnchorRef,
		dropIndicator,
		dragPreview,
		dropTargetRef,
		isDraggable,
		isDragging: state.type === 'dragging',
	};
}
